import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-checkliste-lkt-bioair',
  templateUrl: './form-checkliste-lkt-bioair.component.html',
  styleUrls: ['./form-checkliste-lkt-bioair.component.scss', '../checklisten.scss'],
})
export class FormChecklisteLktBioairComponent implements OnInit {
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit() {}
}
